import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { EntregaProjeto } from '../../models/entregas-projeto.model';
import { PlanoAcao } from '../../models/plano-acao.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresAtividadeService } from '../../services/indicadores-atividade.service';
import { IndicadoresPgAtividadeService } from '../../services/indicadores-pg-atividade.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { PlanoAcaoService } from '../../services/plano-acao.service';

@Component({
  selector: 'app-detalhe-projeto-plano-acao-list',
  templateUrl: './detalhe-projeto-plano-acao-list.component.html',
  styleUrls: ['./detalhe-projeto-plano-acao-list.component.scss']
})
export class DetalheProjetoPlanoAcaoListComponent extends BaseListComponent<PlanoAcao> implements OnInit, OnDestroy {

  @Input() isProjeto: boolean = true;
  @Input() idEntrega: number;
  @Input() idIndicador: number;
  @Input() idPgIndicador: number;
  @Input() type: string;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  title: string;
  planoAcao: PlanoAcao[];
  permission: any;
  ordenacao: boolean;
  deletedActive: boolean = false;
  deletedActiveDrop: boolean = false;
  offTypeList: string = 'Atividade';

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(
    private planoAcaoService: PlanoAcaoService,
    private atividadeService: IndicadoresAtividadeService,
    private pgAtividadeService: IndicadoresPgAtividadeService,
    public activatedRoute: ActivatedRoute,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    if (this.idEntrega) {
      this.title = 'Plano de Ação (iniciativas associadas ao entregavel)';
      this.offTypeList = 'Plano de Ação';
      this.addSub(
        this.planoAcaoService.getListAll(this.idEntrega).subscribe({
          next: (res) => {
            this.planoAcao = res['actions'];
            this.permission = res['permission'];
            this.loaded();
          },
          error: (err) => {
            this.loaded();
          },
        })
      );
    }
    else if (this.idIndicador) {
      this.title = 'Atividades';
      this.addSub(
        this.atividadeService.getListAll(this.idIndicador).subscribe({
          next: (res) => {
            this.planoAcao = res['actions'];
            this.permission = res['permission'];
            this.loaded();
          },
          error: (err) => {
            this.loaded();
          },
        })
      );
    }
    else if (this.idPgIndicador) {
      this.title = 'Atividades';
      this.addSub(
        this.pgAtividadeService.getListAll(this.idPgIndicador).subscribe({
          next: (res) => {
            this.planoAcao = res['actions'];
            this.permission = res['permission'];
            this.loaded();
          },
          error: (err) => {
            this.loaded();
          },
        })
      );
    }
  }

  newViewLink(id: any = 'adicionar') {
    if (this.idEntrega) {
      return ['/projetos', 'projeto', this.idProjeto, 'plano-acao', id];
    } else if (this.idIndicador) {
      return ['/projetos', 'projeto', this.idProjeto, 'atividade', id];
    } else if (this.idPgIndicador) {
      return ['/projetos', this.type ?? 'agregador', 'atividade', id];
    }
  }

  novoParams(){
    if (this.idEntrega) {
      return { prt_issue_id: this.idEntrega };
    } else if (this.idIndicador) {
      return { ind_id: this.idIndicador };
    } else if (this.idPgIndicador) {
      return { pg_ind_id: this.idPgIndicador };
    }
  }

  novaDemandaLink() {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', 'adicionar'];
  }

  novaDemandaParams(id: number) {
    if (this.idEntrega) {
      return { pf_prt_issue_action_id: id };
    } else if (this.idIndicador) {
      return { pf_ind_action_id: id };
    }
  }

  novaSituacao(id: number) {
    if (this.idEntrega) {
      return ['/projetos', 'projeto', this.idProjeto, 'plano-acao', 'situacao', id, 'adicionar'];
    } else if (this.idIndicador) {
      return ['/projetos', 'projeto', this.idProjeto, 'atividade', 'situacao', id, 'adicionar'];
    } else if (this.idPgIndicador) {
      return ['/projetos', this.type ?? 'agregador', 'atividade', 'situacao', id, 'adicionar'];
    }
  }

  onMouseDown(event: MouseEvent) {
    this.deletedActiveDrop = true;
  }

  drop(event: CdkDragDrop<string[]>) {
    console.log('teste 2')
    this.ordenacao = true;
    moveItemInArray(this.planoAcao, event.previousIndex, event.currentIndex);
    this.planoAcao.forEach((item, index) => {
      item.nro_ord = index + 1;
    })
    this.deletedActiveDrop = false;
  }

  getDataCreateOrder(): any {
    return {
      pf_prt_issue_order: this.planoAcao.map((item) => {
        return { id: item.id, nro_ord: item.nro_ord };
      })
    }
  }

  salvarOrdem() {
    this.loading();
    this.ordenacao = false;

    if (this.idEntrega) {
      this.addSub(
        this.planoAcaoService.salvarOrdem(this.getDataCreateOrder()).subscribe({
          next: (res) => {
            this.msgSuccess("Ordem Salva com Sucesso!");
            this.loaded();
          },
          error: (err) => {
            this.msgError(err?.error?.message);
            this.loaded();
          },
        })
      )
    } else if (this.idIndicador) {
      this.addSub(
        this.atividadeService.salvarOrdem(this.getDataCreateOrder()).subscribe({
          next: (res) => {
            this.msgSuccess("Ordem Salva com Sucesso!");
            this.loaded();
          },
          error: (err) => {
            this.msgError(err?.error?.message);
            this.loaded();
          },
        })
      )
    } else if (this.idPgIndicador) {
      this.addSub(
        this.pgAtividadeService.salvarOrdem(this.getDataCreateOrder()).subscribe({
          next: (res) => {
            this.msgSuccess("Ordem Salva com Sucesso!");
            this.loaded();
          },
          error: (err) => {
            this.msgError(err?.error?.message);
            this.loaded();
          },
        })
      )
    }
  }

  solicitarNovaSituacao() {
    this.loading();
    if (this.idEntrega) {
      this.addSub(
        this.planoAcaoService.solicitarNovaSituacao(this.idEntrega).subscribe({
          next: (res) => {
            this.msgSuccess("Solicitação enviada com Sucesso!");
            this.loaded();
          },
          error: (err) => {
            this.msgError(err?.error?.message);
            this.loaded();
          },
        })
      )
    } else if (this.idIndicador) {
      this.addSub(
        this.atividadeService.solicitarNovaSituacao(this.idIndicador).subscribe({
          next: (res) => {
            this.msgSuccess("Solicitação enviada com Sucesso!");
            this.loaded();
          },
          error: (err) => {
            this.msgError(err?.error?.message);
            this.loaded();
          },
        })
      )
    } else if (this.idPgIndicador) {
      this.addSub(
        this.pgAtividadeService.solicitarNovaSituacao(this.idPgIndicador).subscribe({
          next: (res) => {
            this.msgSuccess("Solicitação enviada com Sucesso!");
            this.loaded();
          },
          error: (err) => {
            this.msgError(err?.error?.message);
            this.loaded();
          },
        })
      )
    }
  }

  deletedVerify() {
    return this.planoAcao?.length == this.planoAcao?.filter(item => item?.deleted)?.length;
  }

  viewResonsavel(entrega: EntregaProjeto) {
    this.modalResonsavel.openModal([entrega, ...entrega?.resp_adj]);
  }
}
